// Dual-write / encrypted-follower runtime config (stabilization build v2).
// ADDITIVE + DEFAULT-OFF: these build-time tokens are OPTIONAL. When unset, the
// portal runs single-write against the authoritative API exactly as today. Only
// the encrypted-stack portal build (app2.virtualid.one) sets them.
//
// Kept separate from src/config.ts so the existing config surface is unchanged.

declare const __VID_ENC_API_BASE__: string | undefined;
declare const __VID_DUAL_WRITE__: string | undefined;

function readToken(getter: () => string | undefined): string | undefined {
  try {
    const v = getter();
    return typeof v === 'string' && v.length > 0 ? v : undefined;
  } catch {
    // Token not defined at build time (default build) => undefined.
    return undefined;
  }
}

export const encConfig = {
  /** Base URL of the encrypted follower API (api2.). Undefined => not configured. */
  encApiBase: readToken(() => (typeof __VID_ENC_API_BASE__ !== 'undefined' ? __VID_ENC_API_BASE__ : undefined)),
  /** Master dual-write switch. Defaults OFF unless explicitly "true". */
  dualWriteEnabled:
    readToken(() => (typeof __VID_DUAL_WRITE__ !== 'undefined' ? __VID_DUAL_WRITE__ : undefined)) === 'true',
};

/** Dual-write is only active when explicitly enabled AND an encrypted base exists. */
export function dualWriteActive(): boolean {
  return encConfig.dualWriteEnabled && !!encConfig.encApiBase;
}
